const assetPath = process.env.ASSET_PATH
__webpack_public_path__ =
  assetPath && assetPath !== '__ASSETS_URL__' && assetPath !== '/'
    ? assetPath
    : `${window.__CONFIG__?.assetsUrl || '/'}`
